<template>
  <div class="schedule-link-components">
    <div class="schedule-link">
      <router-link to="/schedule">
        <div class="image">
          <img src="../../assets/img/job/link_image.jpg" alt="">
        </div>
        <div class="link-text-wrapper">
          <div class="link-text">
            <p>
              <img src="../../assets/img/job/logo.svg" alt="sanwa">
              社員の<br>
              1日の過ごしかた
            </p>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScheduleLink',
}
</script>
<style scoped lang="scss">
.schedule-link {
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 50px;
  a {
    display: flex;
    justify-content: center;
    &:hover {
      .link-text:after {
        transform: translate(10px);
      }
    }
  }
}
.image {
  width: 290px;
  overflow: hidden;
  height: 180px;
  @media print, screen and (max-width: 750px) {
    width: 100px;
    height: 100px;
  }
  img {
    vertical-align: middle;
    max-width: unset;
    height: 100%;
  }
}
.link-text-wrapper {
  background-image: linear-gradient(-25deg,	#ffce48 25%,#b6b6b6 25%,#b6b6b6 50%,#ffce48 50%,#ffce48 75%,#b6b6b6 75%,#b6b6b6);
  background-size: 600px 600px;
  width: calc(100% - 290px);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
  @media print, screen and (max-width: 750px) {
    width: calc(100% - 100px);
    background-image: linear-gradient(-25deg,	#ffce48 25%,#b6b6b6 25%,#b6b6b6 50%,#ffce48 50%,#ffce48 75%,#b6b6b6 75%,#b6b6b6);
    background-size: 300px 300px;
    height: 100px;
  }
}
.link-text {
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #e51c57;
  justify-content: space-between;
  max-width: 300px;
  width: 100%;
  line-height: 2em;
  @media print, screen and (max-width: 750px) {
    font-size: 18px;
    max-width: 200px;
  }
  &:after {
    content: url('../../assets/img/common/icon/circle_arrow_next_pink.svg');
    width: 37px;
    display: block;
    transition: transform 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  img {
    vertical-align: middle;
    display: inline;
    max-width: 153px;
    height: 1em;
  }
  p {
    max-width: 100%;
    width: 100%;
  }
}
</style>
